<ui-form-autocomplete [data]="autocompleteConfig()" [formControl]="control"></ui-form-autocomplete>
